import { Icon } from "@sellar-io/components";

export type HomeNotificationKind =
  | "actionRequired"
  | "cardFailed"
  | "creditFailed"
  | "addToTab"
  | "deliveryDelayed";

export function HomeNotificationIcon({ kind }: { kind: HomeNotificationKind }) {
  const isError =
    kind === "cardFailed" ||
    kind === "creditFailed" ||
    kind === "actionRequired";
  const icons = {
    actionRequired: "ALERT_FILLED",
    cardFailed: "CREDIT_CARD_FAST_OUTLINE",
    creditFailed: "ALERT_FILLED",
    addToTab: "SELLAR_NEW",
    deliveryDelayed: "SELLAR_DISTRIBUTION_TRUCK",
  } as const;
  return (
    <span
      aria-hidden="true"
      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${isError ? "bg-red-50 text-red-800" : "bg-purple-50 text-[#8C23C7]"}`}
    >
      {kind === "addToTab" ? (
        <img
          src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellar-icon-gradient.svg"
          width={16}
          height={16}
          alt=""
        />
      ) : (
        <Icon icon={icons[kind]} size="16px" />
      )}
    </span>
  );
}
